import {request} from './repository';
import _ from 'lodash';

const url = 'source-procedure-situations/'

const sourceProcedureSituationStore = {
    getSourceProcedureSituations(source_procedure) {
        return request.get(
            `source-procedures/${source_procedure}/source-procedure-situations`
        );
    },

    storeSourceProcedureSituation(data) {
        return request.post(url, data);
    },

    updateSourceProcedureSituation(id, data) {
        data = _.pick(data, ['next_organizations', 'source_procedure_id', 'source_situation', 'observation_required', 'enabled', 'next_source_procedure', 'service_status_id'])
        let form = {
            enabled: data.enabled,
            next_organizations: data.next_organizations,
            source_procedure_id: data.source_procedure_id,
            observation_required: data.observation_required,
            next_source_procedure_id: data.next_source_procedure?.id,
            source_situation_id: data.source_situation.id,
            service_status_id: data.service_status_id
        }

        return request.put(url + id, form);
    },

    deleteSourceProcedureSituation(id_situacao) {
        return request.delete(url + id_situacao);
    },

    fetchNextSourceProcedureOrganizations(source_procedure_id) {
        return request.get(
            `source-procedure/${source_procedure_id}/next-procedure-organizations`
        );
    },

    createNewSituation(data) {
        return request.post('source-situations', data)
    },


}

export default sourceProcedureSituationStore;

